import React, { ReactNode } from 'react';
import { RuleSet } from 'styled-components';
import { ResidenceSectionContainer, ResidenceSectionTitle } from './styled';

interface ResidenceSectionProps {
  children: ReactNode;
  title?: string;
  styles?: RuleSet<object>;
  sectionId?: string;
}

export const ResidenceSection: React.FC<ResidenceSectionProps> = ({
  children,
  title,
  styles,
  sectionId = 'residence-section'
}) => {
  return (
    <ResidenceSectionContainer $styles={styles} id={sectionId}>
      {title && <ResidenceSectionTitle tag="h2">{title}</ResidenceSectionTitle>}
      {children}
    </ResidenceSectionContainer>
  );
};
